export default __webpack_public_path__ + "static/media/bg-claro.2f28583d.svg";